import React from 'react';
import i18next from 'i18next';

import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import GroupsView from './view/GroupsView';
import GroupsDetails from './details/GroupsDetails';

import buttons from './GroupsButtons';
import events from './GroupsEvents';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('groups'),
	routes: [
		{
			path: 'groups/add/:tabId?',
			auth: ({ authorizer }) => authorizer.can('create', 'groups'),
			element: (
				<DetailsPage
					key="groups/add"
					module="groups"
					headerOptions={{ showAvatar: true }}
					tabs={GroupsDetails}
					buttons={buttons.details}
					events={events}
					isAdd
				/>
			)
		},
		{
			path: 'groups/details/:id/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'groups'),
			element: (
				<DetailsPage
					key="groups/details"
					module="groups"
					headerOptions={{ showAvatar: true }}
					tabs={GroupsDetails}
					buttons={buttons.details}
					events={events}
				/>
			)
		},
		{
			path: 'groups/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'groups'),
			element: (
				<ViewPage
					key="groups/view"
					module="groups"
					content={{ type: 'tabs', tabs: GroupsView }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
